import styled from '@emotion/styled';
import { useListingContext } from '~/editor/plugin/ListingPlugin';

const Section = styled.section`
	padding: 2rem 1.5rem 6rem;
`;

const Inner = styled.div`
	max-width: 72rem;
	margin: 0 auto;
`;

const Stats = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 1.5rem 3rem;
	text-transform: uppercase;
	margin-bottom: 2rem;
`;

const Stat = styled.div`
	display: flex;
	align-items: center;
	gap: 0.75rem;
`;

const StatValue = styled.span`
	font-size: 3rem;
	font-weight: 500;
`;

const StatLabel = styled.span`
	font-size: 1rem;
	color: #6b7280;
`;

const Body = styled.div`
	font-size: 2rem;
	line-height: 2.5rem;
	max-width: 36rem;
`;

const ReadMore = styled.a`
	display: inline-flex;
	align-items: center;
	gap: 0.75rem;
	margin-top: 1.5rem;
	padding: 0.75rem 0;
	border-bottom: 2px solid black;
	text-transform: uppercase;
	font-weight: 500;
	font-size: 1.25rem;
`;

function formatLotSize(lotAcres?: number, lot?: number) {
	if (lotAcres) {
		return `${lotAcres.toFixed(2)} acres`;
	}
	if (lot) {
		return `${lot.toLocaleString()} sqft`;
	}
	return null;
}

export default function ListingBlockDelta() {
	const listing = useListingContext();
	const lotSize = formatLotSize(listing.lot_acres, listing.lot);

	return (
		<Section id="overview">
			<Inner>
				<Stats>
					{listing.beds != null && (
						<Stat>
							<StatValue>{listing.beds}</StatValue>
							<StatLabel>Beds</StatLabel>
						</Stat>
					)}
					{listing.baths != null && (
						<Stat>
							<StatValue>{listing.baths}</StatValue>
							<StatLabel>Baths</StatLabel>
						</Stat>
					)}
					{listing.sqft != null && (
						<Stat>
							<StatValue>{listing.sqft.toLocaleString()}</StatValue>
							<StatLabel>Sqft</StatLabel>
						</Stat>
					)}
					{lotSize && (
						<Stat>
							<StatValue>{lotSize}</StatValue>
							<StatLabel>Sf Lot</StatLabel>
						</Stat>
					)}
				</Stats>
				{listing.body && (
					<>
						<Body>{listing.body}</Body>
						<ReadMore href="#description">Read More →</ReadMore>
					</>
				)}
			</Inner>
		</Section>
	);
}
